// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"297":"2cd211ed","643":"ef54e615"}[chunkId] + ".chunk.js";
};